import React, {useEffect, useState} from "react";
import {useAuth} from "../../../context";
import {Link, useParams} from "react-router-dom";
import {useInterval, usePostJson} from "../../../hooks";
import {endpoints} from "../../../utils2";
import {WhiteCard} from "../_components/WhiteCard";
import {ABOverlayPopover} from "../../_components/CustomOverlayTooltip";
import {TableLikeText} from "../../_components";
import {isoTimestampToReadableDateOnly} from "../../backend2/admin/utilities/readableDate";
import {Alert, Button} from "react-bootstrap";
import {useTopicSSE} from "../../../hooks/useTopicSSE";
import {SseTopics} from "../../../context/SSEContext";

export function DeviceSection({device}) {
    const online = useTopicSSE(SseTopics.Online)

    return <>
        {online && <WhiteCard className="flex-grow-1">
            <DeviceCard online={online} device={device}/>
        </WhiteCard>}
    </>
}

function DeviceCard({online, device}) {
    const {admin, authToken} = useAuth()

    const rtcc = useTopicSSE(SseTopics.RTCC)
    const dev = useTopicSSE(SseTopics.Device)

    const {uid, did} = useParams()
    const [dynDate, setDynDate] = useState(0)

    useEffect(() => {
        setDynDate(online && rtcc?.date ? rtcc?.date : 0)
    }, [online, rtcc])

    useInterval(() => {
        if (online) {
            setDynDate(prev => prev ? prev + 1 : 0)
        }
    }, 1000, [online])

    // const [rebootPush, rebootValue, rebootLoadingPush, rebootErrorPush, clearRebootErrorPush] = usePostJson(endpoints.push.reboot(uid, did), authToken?.jwt)
    //
    // function handleInstall() {
    //     console.log("Installing...")
    //     rebootPush({reboot: true, upgrade: true})
    // }

    if (dev)
        return <>
            <ABOverlayPopover buttonLabel="Device details" headerText="Additional details">
                <div>
                    <TableLikeText titleColor="text-light" title="Name" value={dev.prjName}/>
                    <TableLikeText titleColor="text-light" title="Code" value={dev.prjCode}/>
                    <TableLikeText titleColor="text-light" title="Hardware" value={dev.hard}/>
                    <TableLikeText titleColor="text-light" title="Build date" value={dev.date}/>
                    <TableLikeText titleColor="text-light" title="Build time" value={dev.time}/>
                    {dev?.MCU && <TableLikeText titleColor="text-light" title="MCU" value={dev.MCU}/>}
                    <TableLikeText titleColor="text-light" title="Device ID" value={dev.devid?.toString(16)}/>
                    <TableLikeText titleColor="text-light" title="Device VER" value={dev.devver}/>
                    <TableLikeText titleColor="text-light" title="User ID" value={dev.userid}/>
                    {admin && device?.updated_at &&
                        <TableLikeText titleColor="text-light" title="Updated" value={isoTimestampToReadableDateOnly(device?.updated_at)}/>}
                </div>
            </ABOverlayPopover>

            <TableLikeText title="Activated" value={isoTimestampToReadableDateOnly(device?.created_at)}/>
            <TableLikeText title="NTP" value={<Link to={`/device/${uid}/${did}/config/ntp`}
                                                    className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">{rtcc?.NTP || "Undef."}</Link>}/>
            <TableLikeText title="Clock" value={new Date(Number(dynDate) * 1000).toLocaleString()}/>
            <TableLikeText title="Build" value={`v${dev.firm} ${dev.fname}, build on ${dev.date}`}/>
            {/*<TableLikeText title="Build" value={dev.LFW}/>*/}
            {/*{dev.LFW &&*/}
            {/*        <Alert variant="danger" show={dev.LFW !== dev.firm} className="p-2">*/}
            {/*            <div className="d-flex flex-column">*/}
            {/*                <div className="d-flex align-items-center">*/}
            {/*                    <i className="bi bi-info-circle me-2 fs-4"/>*/}
            {/*                    <div className="fw-semibold fs-5">Firmware {dev.LFW} update available.</div>*/}
            {/*                </div>*/}
            {/*                <div>Download and install now to improve performance and security. The device will <strong>automatically reboot</strong> during installation.*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <Button variant="danger" className="mt-2" onClick={handleInstall}>Install now</Button>*/}
            {/*        </Alert>*/}
            {/*}*/}
        </>
    else
        return null
}
